import ChangeTHsModal from "./ChangeTHsModal";

export default ChangeTHsModal;
